import firebase from 'firebase/app';

export const SaveEditedContentInfirebase = (fbProfile,auth, docId,editedContent) => {
    firebase
        .firestore()
        .collection('organizations')
        .doc(fbProfile.company)
        .collection('searchedContactLastFive')
        .doc(auth.uid)
        .collection('searchedContact')
        .doc(docId)
        .update({
            message: editedContent
        })

        firebase
        .firestore()
        .collection('organizations')
        .doc(fbProfile.company)
        .collection('prospects')
        .doc(docId)
        .update({
            message: editedContent
        })
}